import { render } from "./authorizationModel.vue?vue&type=template&id=74aab42d"
import script from "./authorizationModel.vue?vue&type=script&lang=js"
export * from "./authorizationModel.vue?vue&type=script&lang=js"

import "./authorizationModel.vue?vue&type=style&index=0&id=74aab42d&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__